<template>
  <tr class="opportunity-list-item">
    <td>{{ region.name | nullable }}</td>
    <td>{{ adminEmail.toString() | nullable }}</td>
    <td>{{ region.from_email | nullable }}</td>
    <td>
      <button class="edit-button" @click="$emit('edit', region.id)">
        <i class="fa fa-fw fa-pencil-square-o" />
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    region: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      adminEmail: ''
    }
  },

  watch: {
    'region' (newValue, oldValue) {
      if (newValue.admin_email !== null) {
        this.adminEmail = newValue.admin_email
      }
    }
  },

  created () {
    this.adminEmail = this.region.admin_email.includes('[') ? JSON.parse(this.region.admin_email) : this.region.admin_email
  }
}
</script>
